import React, { useMemo, useState } from 'react'
import { AdminFilterContext, AdminFilterValue } from './AdminFilterContext'
import { ADMIN_DEFAULT_WINDOW_DAYS, presetRange } from './dateRange'

/** The initial range: the "Last 30 days" preset, so the dashboard opens usefully scoped. */
const defaultRange = (): { from: string; to: string } => presetRange(ADMIN_DEFAULT_WINDOW_DAYS)

export const AdminFilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [range, setRange] = useState(defaultRange)
	// Default off: the dashboard opens showing real customer signal, not internal data.
	const [includeInternal, setIncludeInternal] = useState(false)

	const value = useMemo<AdminFilterValue>(
		() => ({
			from: range.from,
			to: range.to,
			setRange: (from, to) => setRange({ from, to }),
			includeInternal,
			setIncludeInternal,
		}),
		[range, includeInternal],
	)

	return <AdminFilterContext.Provider value={value}>{children}</AdminFilterContext.Provider>
}
